import axios from 'axios';

const skiPassApiBaseURL = 'https://ski-pass.polyanaski.ru';
// const skiPassApiBaseURL = 'http://10.25.3.144';
const skiPassApi = axios.create({
    baseURL: skiPassApiBaseURL
});

export {skiPassApiBaseURL, skiPassApi};